<template>
    <div>
      <van-nav-bar
        :title="$t('app.detailed_log.title')"
        :left-text="$t('app.common.back')"
        left-arrow
        @click-left="$router.push('/member/members')"
        class=""
      />
      <van-tabs v-model="active" animated @click="getListLog">
        <van-tab v-for="(item,index) in title" :title=$t(item) :key="index" >
          <van-pull-refresh v-model="isLoading[index]" @refresh="onRefresh(active)" :pulling-text="$t('app.common.pull_to_reload')":loosing-text="$t('app.common.release_to_reload')":loading-text="$t('app.common.loading')">
            <van-loading v-if="showLoading" style="text-align: center;" />
            <van-cell-group>
              <van-cell v-for="(item1,index1) in listLog[index]" :key="index1">
                <template #title>
                  <span v-if="item1.capital">{{ $t(item1.capital) }}</span> {{ $t(item1.name) }} 
                </template>
                <template #label>
                  {{ $getDeviceTime(item1.time) }}
                </template>
                <template #default>
                  <div v-if="item1.number">
                    <span class="red" v-if="Number(item1.number) >= 0">{{ Number(item1.number).toFixed(2) }}{{$t("app.common.currency")}}</span>
                    <span class="green" v-else>{{ Number(item1.number).toFixed(2) }}{{$t("app.common.currency")}}</span>
                    <br v-if="(item1.exchange)"><span style="color:#000000" v-if="(item1.exchange)">{{ Number(item1.exchange).toFixed(2) }}{{$t("app.withdraw.rmb")}}</span> 
                    <br>{{$t("app.detailed_log.balance")}}:{{ Number(item1.balance).toFixed(2) }}{{$t("app.common.currency")}}
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
</template>

<script>
    export default {
        name: "DetailedLog",
      data(){
          return{
            active:0,
            title:["app.detailed_log.all_detail","app.detailed_log.depositl","app.detailed_log.withdraw","app.detailed_log.loan","app.detailed_log.profit_withdraw","app.detailed_log.management_fee","app.detailed_log.voucher","app.detailed_log.cash_back"],
            methods:['all_log','recharge_log','withdraw_log','loan_log','extract_log','manage_log','vouchermanage_log','give_back'],
            isLoading:[false,false,false,false,false,false,false,false],
            listLog:[
              [],[],[],[],[],[],[],[],
            ],
            showLoading:false,
          }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
       },
        getListLog(name){
          let that = this;
          if (that.listLog[name].length === 0){
            that.showLoading=true;
            if (name === 7){
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: 'all_log',
                  token: sessionStorage.getItem("token"),
                  type:14
                }
              })
                .then(function(res) {
                  that.showLoading=false;
                  let resData = res.data;
                  if (resData.code === 1) {
                    if (resData.data.length === 0){
                      that.addData(name,resData.data)
                    }else{
                      that.$set(that.listLog,name,resData.data);
                    }
                    // that.listLog[name] = resData.data;
                  } else if (resData.code === 0) {
                    that.$toast.fail(that.$t(res.data.msg));
                  }
                });
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: that.methods[name],
                  token: sessionStorage.getItem("token")
                }
              })
                .then(function(res) {
                  that.showLoading=false;
                  let resData = res.data;
                  if (resData.code === 1) {
                    switch (name) {
                      case 1:
                      case 2:
                        if (resData.data.data.length === 0){
                          that.addData(name,resData.data.data)
                        }else{
                          that.$set(that.listLog,name,resData.data.data);
                        }
                        break;
                      default:
                        if (resData.data.length === 0){
                          that.addData(name)
                        }else{
                          that.$set(that.listLog,name,resData.data);
                        }
                        break;
                    }
                  } else if (resData.code === 0) {
                    that.$toast.fail(that.$t(res.data.msg));
                  }
                });
            }
          }
        },
        addData(name,data){
        },
        onRefresh(name){
          let that = this;
          if (name === 7){
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_log',
                token: sessionStorage.getItem("token"),
                type:14
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  if (resData.data.length === 0){
                    that.addData(name,resData.data)
                  }else{
                    that.$set(that.listLog,name,resData.data);
                  }
                  // that.listLog[name] = resData.data;
                } else if (resData.code === 0) {
                  that.$toast.fail(that.$t(res.data.msg));
                }
              });
          }else{
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: that.methods[name],
                token: sessionStorage.getItem("token")
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  switch (name) {
                    case 1:
                    case 2:
                      if (resData.data.data.length === 0){
                        that.addData(name,resData.data.data)
                      }else{
                        that.$set(that.listLog,name,resData.data.data);
                      }
                      break;
                    default:
                      if (resData.data.length === 0){
                        that.addData(name)
                      }else{
                        that.$set(that.listLog,name,resData.data);
                      }
                      break;
                  }
                } else if (resData.code === 0) {
                  that.$toast.fail(that.$t(res.data.msg));
                }
              });
          }
        },
      },
      mounted:function () {
        this.isLogin();
        if(this.$route.params.tab){
          this.active = parseInt(this.$route.params.tab);
          this.getListLog(this.active);
        }else{
          this.getListLog(0);
        }
      },
    }
</script>

<style scoped>
  .red{
    color: red;
  }
  .green{
    color: green;
  }

  .navStyle{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailedLog.vue